<template>
  <div class="simple-card-wrapper">
    <div class="simple-card md:block">
      <div
        v-if="circleContent"
        class="simple-card__circle mb-5"
        v-html="circleContent"
      ></div>

      <div
        v-if="image || $slots.image"
        class="simple-card__image-wrapper block"
      >
        <div class="button--pure simple-card__link text-center">
          <slot
            name="image"
            v-bind="{ image, title, link, imageHeight, imageWidth }"
          >
            <NuxtLazyImg
              :alt="title"
              :height="$device.isDesktopOrTablet ? 280 : 270"
              :src="String(image)"
              class="simple-card__img mx-auto d-block h-[280px] object-cover w-full"
              width="100%"
            />
          </slot>
        </div>
      </div>

      <div class="simple-card__content text-start">
        <div class="button--pure simple-card__link">
          <slot name="title" v-bind="{ title, link }">
            <div class="simple-card__title mt-4">
              {{ title }}
            </div>
          </slot>
        </div>
        <div v-if="description" class="button--pure simple-card__link">
          <slot name="description" v-bind="{ description, link }">
            <span class="simple-card__description">
              {{ description }}
            </span>
          </slot>
        </div>
        <slot name="linkText" v-bind="{ linkText, link }">
          <UnderlineHoverAnimation>
            <a
              v-if="linkText && link && useNativeAnchor"
              :href="String(link)"
              class="transition-colorsa mt-3 block text-base hover:shadow-teal font-medium hover:text-teal-700"
            >
              {{ linkText }}
            </a>
            <NuxtLink
              v-else-if="linkText && link"
              :to="link"
              class="transition-colorsa mt-3 block text-base hover:shadow-teal font-medium hover:text-teal-700"
            >
              {{ linkText }}
            </NuxtLink>
          </UnderlineHoverAnimation>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    /**
     * Card image
     */
    image: {
      type: [Array, Object, String],
      default: '',
    },

    /**
     * Card image width, without unit
     */
    imageWidth: {
      type: [String, Number],
      default: '100%',
    },

    /**
     * Card image height, without unit
     */
    imageHeight: {
      type: [String, Number],
      default: '100%',
    },

    /**
     * Card title
     */
    title: {
      type: String,
      default: '',
    },

    /**
     * Card description
     */
    description: {
      type: String,
      default: '',
    },

    /**
     * Link
     */
    link: {
      type: [String, Object],
      default: '',
    },

    /**
     * Link Text
     */
    linkText: {
      type: [String, Object],
      default: '',
    },

    /**
     * Link
     */
    handleClick: {
      type: Boolean,
      default: false,
    },
    useNativeAnchor: {
      type: Boolean,
      default: false,
    },

    /**
     * Item index
     */
    circleContent: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      isAddingToCart: false,
    }
  },
  computed: {},
  methods: {},
}
</script>

<style lang="css">
@reference '~/assets/css/tailwind.css';
.simple-card {
  column-gap: 1rem;
  display: flex;
  flex-wrap: wrap;
}

.simple-card__circle {
  border-radius: 50%;
  font-size: 20px;
  width: 45px;
  height: 45px;
  background: #cced3a;
  color: #026166;
  @apply font-lexend font-bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.simple-card__image-wrapper {
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  height: auto;
  max-height: 250px;
}

.simple-card__img {
  @apply duration-300 ease-in-out;

  .simple-card-wrapper:hover & {
    @apply scale-105;
  }
}

.simple-card__title {
  @apply text-h5;
}

.simple-card__description {
  @apply text-stone-700 text-sm;
}

.simple-card__image {
  width: 100%;
  height: auto;
  border-radius: 0.5rem;
}

.simple-card__content {
  flex: 1;
}

@media (min-width: 992px) {
  .simple-card {
    column-gap: 20rem;
  }
}
</style>
